<template>
  <b-modal
    modal-class="confirm-modal"
    :title="title"
    ref="dialog"
    @ok="$emit('ok')"
    @cancel="$emit('cancel')"
    @hidden="$emit('hidden')"
    cancel-variant="link text-secondary"
    :ok-variant="okVariant"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :id="id"
    :hide-header="hideHeader"
    :visible="value"
    @change="$emit('input', $event)"
    auto-focus-button="cancel"
    hide-header-close
  >
    <!-- @slot This contains the body of confirmation dialog -->
    <slot></slot>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

/**
 * This given a confirmation dialog. User has option to either accept/cancel.
 *
 * emits:
 * - ok: emitted when user accepts(clicks on OK Button)
 */
export default {
  name: 'ConfirmDialog',
  components: {
    BModal
  },
  props: {
    okTitle: { type: String, default: 'OK' },
    okVariant: { type: String, default: 'primary' },
    cancelTitle: { type: String, default: 'Cancel' },
    title: { type: String, default: '' },
    id: { type: String },
    hideHeader: { type: Boolean },
    value: { type: Boolean }
  },
  methods: {
    show() {
      this.$refs.dialog.show()
    }
  }
}
</script>

<style lang="scss">
.confirm-modal .modal-content {
  padding: 30px;
}

.confirm-modal header {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.confirm-modal .modal-body {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
}

.confirm-modal header + .modal-body {
  padding-top: 16px;
}

.confirm-modal footer {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

.confirm-modal button {
  border-radius: 20px;
  padding: 4px 16px;
}
</style>
